import React, { useState, useEffect, useMemo } from 'react';
import DatePicker from "react-datepicker";
import EmployeeSelector from '../employee/selector.js';
import NumericInput from 'react-numeric-input';
import FieldSelector from '../farm/field/selectorfarm.js';
import InputWrapper from '../forms/InputWrapper.js';
import TaskSelector from './TaskSelector.js';
import Loadable from '../ui/loading/Loadable.js';
import ShowIff from '../ui/ShowIff.js';

import { callback } from '../../helpers.js';

import api from '../../api/index.js';


export default (props) => {
	if (props.data === false) return '';

	console.log("props", props);
	const [employee, setEmployee] = useState(props.data.EmployeeID);
	const [date, setDate] = useState(api.date(props.data.Date));
	const [field, setField] = useState(props.data.FieldID);
	const [farm, setFarm] = useState(props.data.FarmID);
	const [hours, setHours] = useState(props.data.Hours);
	const [task, setTask] = useState(props.data);

	// If the attendanceId changes, reset the state
	useMemo(() => {
		setEmployee(props.data.EmployeeID);
		setDate(api.date(props.data.Date));
		setField(props.data.FieldID);
		setFarm(props.data.FarmID);
		setHours(props.data.Hours);
		setTask(props.data);
	}, [props.data.AttendanceID])


	const save = async (e) => {
		e.preventDefault();
		// Package the info for saving
		let payload = {
			AttendanceID: props.data.AttendanceID,
			EmployeeID: employee,
			Date: date.api(),
			FieldID: field,
			FarmID: farm,
			Hours: hours,
			Task: task
		}
		
		console.log("Saving", payload);
		
		try {
			let response = await api.put('attendance', payload);
			// Redirect to a different page
			callback(props.onUpdated, [props.data.AttendanceID]);
		} catch(e) {
			api.handleExceptions(e);
			// Should I highlight what's wrong?
		};
	}

	const onChange = (e) => {
		console.log("onChange", e);
		setField(e === null ? 0 : e.FieldID);
		setFarm(e === null ? 0 : e.FarmID);
	}

	return <form>
		<InputWrapper label="Date" info={"The date this entry refers to."}>
			<DatePicker
				className="date"
				selected={date}
				onChange={(d)=>setDate(d)}
			/>
		</InputWrapper>
		<InputWrapper label="Employee" info={"The employee this entry refers to."}>
			<EmployeeSelector onChange={(e)=>setEmployee(e)} employee={employee} />
		</InputWrapper>
		<InputWrapper label="Task" info={"The task they performed."}>
			<TaskSelector date={date} field={field} onChange={(e)=>setTask(e)} task={task} />
		</InputWrapper>
		<InputWrapper label="Hours spent" info={"The employee time they spent doing it."}>
			<NumericInput className="hours" name="hours" min={0} max={24} value={hours} step={0.25} precision={2} onChange={(e)=>setHours(e)} /> hours
		</InputWrapper>
		<InputWrapper label="Field" info={"The field they did it on."}>
			<FieldSelector onChange={onChange} field={field} farm={farm} from={date} until={date} showClear={true} />
		</InputWrapper>
		<button className="block"  onClick={save}>Save</button>
	</form>;
}